import {Component, OnInit} from '@angular/core';
import {PrivateAreaService} from '../../services/private-area.service';
import {ClientService} from '../../services/client.service';
import {ActivatedRoute} from '@angular/router';
import {HistoricRenovation} from '../../models/interface-historic-renovation';
import {PaginationInstance} from 'ngx-pagination';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';


declare var require: any;
const FileSaver = require('file-saver');

@Component({
    selector: 'app-historic-renovation',
    templateUrl: './historic-renovation.component.html',
    styleUrls: ['./historic-renovation.component.scss']
})
export class HistoricRenovationComponent implements OnInit {

    button: HTMLElement;
    contractCode: string;
    dataHistoricRenovations: Array<HistoricRenovation>;
    showLoader: boolean;
    paginatorConfig: PaginationInstance;
    textMessage: string;
    modalId: string;
    noHistoricRenovationText: string;
    faDownload:any;

    constructor(public privateAreaService: PrivateAreaService, public clientService: ClientService,
                private activatedRoute: ActivatedRoute) {
        this.showLoader = false;
        this.paginatorConfig = {
            itemsPerPage: 4,
            currentPage: 1,
            id: 'paginator-renewal-historical'
        };
        this.modalId = 'contracts-bills-modal';
        this.noHistoricRenovationText = '';
        this.faDownload=faDownload;
    }

    ngOnInit(): void {
        this.activatedRoute.url.subscribe(url => {
            this.contractCode = url[1].path;
            this.getHistoricRenovation();
        });
    }

    getHistoricRenovation() {
        this.showLoader = true;
        this.privateAreaService.getHistoricRenovation(this.contractCode).subscribe(res => { // 263730 this.contractCode
            this.dataHistoricRenovations = res;
            this.privateAreaService.showHistoricRenovation = true;
            if (this.dataHistoricRenovations.length === 0) {
                this.noHistoricRenovationText = 'No hay históricos de renovaciones para este contrato';
            } else {
                this.noHistoricRenovationText = '';
            }
            this.showLoader = false;
        }, error => {
            if (error.status === 400) {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el código de contrato no es correcto';
                this.noHistoricRenovationText = 'No hay históricos de renovaciones, este contrato no es correcto';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        });
    }

    downLoadBill(codFacturaRenovacion, index, contractNumber ) {
        document.getElementById(index).classList.add('disabled');
        this.showLoader = true;
        this.privateAreaService.getRenovationBill(codFacturaRenovacion).subscribe(res => {
            FileSaver.saveAs(res, `Factura ${contractNumber}`);
            document.getElementById(index).classList.remove('disabled');
            this.showLoader = false;
        }, error => {
            if (error.status === 400) {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el código de facturación no es válido';
                document.getElementById(this.modalId).classList.remove('d-none');
                document.getElementById(index).classList.remove('disabled');
            } else {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
                document.getElementById(index).classList.remove('disabled');
            }
        });
    }

    downLoadContract(codContract, index, contractNumber) {
        document.getElementById(index).classList.add('disabled');
        this.showLoader = true;
        this.privateAreaService.getContract(codContract).subscribe(res => {
            FileSaver.saveAs(res, `Contrato ${contractNumber}`);
            document.getElementById(index).classList.remove('disabled');
            this.showLoader = false;
        }, error => {
            if (error.status === 400) {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el número de contrato no es válido';
                document.getElementById(this.modalId).classList.remove('d-none');
                document.getElementById(index).classList.remove('disabled');
            } else {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
                document.getElementById(index).classList.remove('disabled');
            }
        });
    }
}
